import Typography from "Components/CommonComponents/Typography";
import React, { useContext, useState } from "react";
import { ConfigProvider, Tabs, TabsProps } from "antd";
import ProgressBarCustom from "utilFunctions/shared/ProgressBarCustom";
import DownArrowIcon from "Assets/Icons/DownArrowIcon";
import {
  BASE_URL,
  FETCH_STUDENT_CONTENT_VIEW,
  FETCH_STUDENT_COURSE,
} from "utilFunctions/Constants/urlConstants";
import { StudentContext } from "Context/StudentContext";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { Col, Collapse, Row, Spinner } from "reactstrap";
import UpArrowIcon from "Assets/Icons/UpArrowIcon";
import EbookIcon from "Assets/Icons/EbookIcon";
import VideoIcon from "Assets/Icons/VideoIcon";
import Practiceicon from "Assets/Icons/Practiceicon";
import AudioIcon from "Assets/Icons/AudioIcon";
import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
interface ICourseSelection {
  chapterLoading?: any;
  courseDetails?: any;
  chapterDetails?: any;
  currentTab?: any;
  setCurrentTab?: any;
  selectePackage?: any;
  selectedCourses?: any;
  fetchStudentCourse?: any;
  collapseOpen?: any;
  setCollapseOpen?: any;
  collapseOpenIndex?: any;
  setCollapseOpenIndex?: any;
}
function ChapterContentList({
  chapterLoading,
  courseDetails,
  chapterDetails,
  currentTab,
  setCurrentTab,
  selectePackage,
  selectedCourses,
  fetchStudentCourse,
  collapseOpen,
  setCollapseOpen,
  collapseOpenIndex,
  setCollapseOpenIndex,
}: ICourseSelection) {
  const { screen }: any = useWindowSize();
  const { selectedStudent } = useContext<any>(StudentContext);
  const [chapterContent, setChapterContent] = useState<any>();

  console.log(chapterDetails, "chapterDetails");
  const switchTab = (tabIndex: any) => {
    setCurrentTab(tabIndex);
    setCollapseOpen(false);
    setChapterContent({});
    const courseId = selectedCourses.id;
    const userClass =
      selectedCourses?.classes && selectedCourses.classes != undefined
        ? selectedCourses.classes[parseInt(tabIndex)]
        : "";
    const url =
      BASE_URL +
      FETCH_STUDENT_COURSE +
      `?psId=${selectedStudent.psid}&packageId=${selectePackage.id}&courseId=${courseId}&userClass=${userClass}`;
    fetchStudentCourse(url);
  };

  const { makeRequest: fetchStudentChapterList } = useGetApi(
    (res) => {
      if (res?.data && res?.data?.chapter) {
        setChapterContent(res.data.chapter);
      }
    },
    (error) => {
      console.log(error);
    }
  );
  const handleDownArrowIcon = (item: any, index: any) => {
    console.log(item, "handleDownArrowIcon");
    setCollapseOpenIndex(index);
    setCollapseOpen(true);
    setChapterContent({});
    const courseId = selectedCourses.id;
    const userClass =
      selectedCourses?.classes && selectedCourses.classes != undefined
        ? selectedCourses.classes[parseInt(currentTab)]
        : "";
    const chpterId = item.id;
    const url =
      BASE_URL +
      FETCH_STUDENT_CONTENT_VIEW +
      `?psId=${selectedStudent.psid}&packageId=${selectePackage.id}&courseId=${courseId}&userClass=${userClass}&nodeId=${chpterId}`;
    fetchStudentChapterList(url);
  };
  const returntabs = (selectedCourses: any, chapterDetailList: any) => {
    const tabitems: TabsProps["items"] = [];
    selectedCourses &&
      selectedCourses.classes &&
      selectedCourses.classes.length &&
      selectedCourses.classes.map((el: any, index: number) => {
        const obj: any = {
          key: String(index),
          label: "Class " + el,
          children:
            chapterDetails && chapterDetails.length > 0 ? (
              <>
                {chapterLoading ? (
                  <div className="d-flex flex-row w-100 h-50 p-5 justify-content-center align-items-center">
                    <Spinner color="info" />
                  </div>
                ) : (
                  <div className="w-100 d-flex flex-column gap-8 mt-2">
                    {chapterDetailList.map((item: any, index: number) => (
                      <div key={index} className="package-row-content-style">
                        <Row className="chapter-content-row-style">
                          <Col
                            xs="12"
                            sm="12"
                            md="6"
                            className="chapter-content-column-style pr-3"
                          >
                            <Typography variant="body3" color="black">
                              {index + 1}.&nbsp;{item.name}
                            </Typography>
                          </Col>

                          <Col
                            xs="12"
                            sm="12"
                            md="6"
                            className={
                              ["xxl", "xl", "lg"].includes(screen)
                                ? "chapter-content-column-style"
                                : "chapter-content-column-style mt-3"
                            }
                          >
                            <div className="w-100 d-flex flex-row justify-content-start align-items-center gap-4">
                              <ProgressBarCustom
                                progress={
                                  item.progress_percentage <= 1
                                    ? item.progress_percentage.toFixed()
                                    : Math.floor(
                                        Number(item.progress_percentage)
                                      )
                                }
                              />
                              {collapseOpen && collapseOpenIndex == index ? (
                                <UpArrowIcon
                                  className="cursor-pointer"
                                  onClick={() => {
                                    setCollapseOpen(false);
                                    setCollapseOpenIndex(null);
                                    setChapterContent({});
                                  }}
                                />
                              ) : (
                                <DownArrowIcon
                                  className="cursor-pointer"
                                  onClick={() => {
                                    handleDownArrowIcon(item, index);
                                  }}
                                />
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Collapse
                          isOpen={collapseOpen && collapseOpenIndex == index}
                        >
                          <Row>
                            <Col sm="6" md="6"></Col>
                            <Col
                              sm="6"
                              md="6"
                              className="chapter-content-column-style"
                            >
                              <div className="chapter-content-elem-style">
                                {chapterContent?.asset_analytics &&
                                  Array.isArray(
                                    chapterContent.asset_analytics
                                  ) &&
                                  chapterContent.asset_analytics.map(
                                    (el: any, index: number) => (
                                      <>
                                        <div
                                          key={index}
                                          className="d-flex flex-row gap-1 pl-2 justify-content-start align-items-center"
                                        >
                                          {el.asset_type == "Ebook" ? (
                                            <EbookIcon />
                                          ) : el.asset_type == "Video" ? (
                                            <VideoIcon />
                                          ) : el.asset_type == "Practice" ? (
                                            <Practiceicon />
                                          ) : el.asset_type == "Audio" ? (
                                            <AudioIcon />
                                          ) : null}
                                          <Typography
                                            variant="subheading3"
                                            color="gray"
                                          >
                                            {el.completed}/{el.count}&nbsp;
                                            {el.asset_type}
                                          </Typography>
                                        </div>
                                      </>
                                    )
                                  )}
                              </div>
                            </Col>
                          </Row>
                        </Collapse>
                      </div>
                    ))}
                  </div>
                )}
              </>
            ) : (
              <div className="d-flex flex-column gap-8 p-3 justify-content-center align-items-center">
                <NoDataFoundIcon />
                <Typography variant="body5" color="gray">
                  {" "}
                  Data not available{" "}
                </Typography>
              </div>
            ),
        };
        tabitems.push(obj);
      });
    return tabitems;
  };

  console.log(
    currentTab,
    chapterDetails.length,
    "chapterContent 204",
    courseDetails,
    selectedCourses
  );
  return (
    <>
      {selectedCourses &&
      selectedCourses.classes &&
      selectedCourses.classes.length ? (
        <>
          <ConfigProvider
            theme={{
              components: {
                Tabs: {
                  inkBarColor: "#008DC4",
                  itemSelectedColor: "#008DC4",
                  titleFontSize: 14,
                },
              },
            }}
          >
            <Tabs
              activeKey={currentTab}
              destroyInactiveTabPane={true}
              items={returntabs(selectedCourses, chapterDetails)}
              onChange={switchTab}
            />
          </ConfigProvider>
        </>
      ) : chapterDetails && chapterDetails.length > 0 ? (
        <>
          {" "}
          {chapterLoading ? (
            <div className="d-flex flex-row w-100 h-50 p-5 justify-content-center align-items-center">
              <Spinner color="info" />
            </div>
          ) : (
            <div className="w-100 d-flex flex-column gap-8 mt-2">
              {chapterDetails.map((item: any, index: number) => (
                <div key={index} className="package-row-content-style">
                  <Row className="chapter-content-row-style">
                    <Col
                      xs="12"
                      sm="12"
                      md="6"
                      className="chapter-content-column-style pr-3"
                    >
                      <Typography variant="body3" color="black">
                        {index + 1}.&nbsp;{item.name}
                      </Typography>
                    </Col>

                    <Col
                      xs="12"
                      sm="12"
                      md="6"
                      className={
                        ["xxl", "xl", "lg"].includes(screen)
                          ? "chapter-content-column-style"
                          : "chapter-content-column-style mt-3"
                      }
                    >
                      <div className="w-100 d-flex flex-row justify-content-between align-items-center gap-4">
                        <ProgressBarCustom
                          progress={
                            item.progress_percentage <= 1
                              ? item.progress_percentage.toFixed()
                              : Math.floor(Number(item.progress_percentage))
                          }
                        />
                        {collapseOpen && collapseOpenIndex == index ? (
                          <UpArrowIcon
                            className="cursor-pointer"
                            onClick={() => {
                              setCollapseOpenIndex(null);
                              setCollapseOpen(false);
                              setChapterContent({});
                            }}
                          />
                        ) : (
                          <DownArrowIcon
                            className="cursor-pointer"
                            onClick={() => {
                              handleDownArrowIcon(item, index);
                            }}
                          />
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Collapse isOpen={collapseOpen && collapseOpenIndex == index}>
                    <Row>
                      <Col sm="6" md="6"></Col>
                      <Col
                        sm="6"
                        md="6"
                        className="chapter-content-column-style"
                      >
                        <div className="chapter-content-elem-style">
                          {chapterContent?.asset_analytics &&
                            Array.isArray(chapterContent.asset_analytics) &&
                            chapterContent.asset_analytics.map(
                              (el: any, index: number) => (
                                <>
                                  <div
                                    key={index}
                                    className="d-flex flex-row gap-1 pl-2 justify-content-start align-items-center"
                                  >
                                    {" "}
                                    {el.asset_type == "Ebook" ? (
                                      <EbookIcon />
                                    ) : el.asset_type == "Video" ? (
                                      <VideoIcon />
                                    ) : el.asset_type == "Practice" ? (
                                      <Practiceicon />
                                    ) : el.asset_type == "Audio" ? (
                                      <AudioIcon />
                                    ) : null}
                                    <Typography
                                      variant="subheading3"
                                      color="gray"
                                    >
                                      {el.completed}/{el.count}&nbsp;
                                      {el.asset_type}
                                    </Typography>
                                  </div>
                                </>
                              )
                            )}
                        </div>
                      </Col>
                    </Row>
                  </Collapse>
                </div>
              ))}
            </div>
          )}
        </>
      ) : (
        <div className="d-flex flex-column gap-8 p-3 justify-content-center align-items-center">
          <NoDataFoundIcon />
          <Typography variant="body5" color="gray">
            {" "}
            Data not available{" "}
          </Typography>
        </div>
      )}
    </>
  );
}

export default ChapterContentList;
